interface PopularAddonsHeaderProps {
  title: string;
  description: string;
}

export function PopularAddonsHeader({
  title,
  description
}: PopularAddonsHeaderProps) {
  return (
    <div
      id="configurator-header"
      className="flex flex-col items-center gap-2 self-center"
    >
      <p className="text-navy text-xl font-semibold">{title}</p>
      <p className="text-center text-sm font-normal text-[#555555]">
        {description}
      </p>
    </div>
  );
}
